import MediaNotAvailable from '@components/media_not_available';
import { Img } from '@xo-union/tk-component-picture';
import React from 'react';
import type { Raw } from 'types/vendor';
import { getVendorImage } from '../../../utils/transformNetworkData';
import Styles from './FourVendorImageGrid.styles.scss';

interface FourVendorImageGridProps {
	vendors: Raw[];
}

export const FourVendorImageGrid: React.FC<FourVendorImageGridProps> = ({
	vendors,
}) => {
	const vendorsWithImages = vendors
		.map((vendor) => ({
			vendor,
			image: getVendorImage(vendor),
		}))
		.filter((item) => item.image !== null)
		.slice(0, 4);

	if (vendorsWithImages.length === 0) {
		return (
			<div
				className={Styles.placeholderWrapper}
				data-testid="celebration-photo-grid-placeholder"
			>
				<MediaNotAvailable />
			</div>
		);
	}

	return (
		<div
			className={Styles.fourVendorsLayout}
			data-testid="celebration-photo-grid-layout4"
		>
			<div
				className={Styles.topRow}
				data-testid="celebration-photo-grid-top-row"
			>
				{vendorsWithImages[0] && (
					<div
						className={Styles.topMainImage}
						data-testid="celebration-photo-grid-top-main-image"
					>
						<Img
							src={vendorsWithImages[0].image as string}
							alt={vendorsWithImages[0].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-0"
						/>
					</div>
				)}
				{vendorsWithImages[1] && (
					<div
						className={Styles.topSideImage}
						data-testid="celebration-photo-grid-top-side-image"
					>
						<Img
							src={vendorsWithImages[1].image as string}
							alt={vendorsWithImages[1].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-1"
						/>
					</div>
				)}
			</div>
			<div
				className={Styles.bottomRow}
				data-testid="celebration-photo-grid-bottom-row"
			>
				{vendorsWithImages[2] && (
					<div
						className={Styles.bottomImageLeft}
						data-testid="celebration-photo-grid-bottom-image-left"
					>
						<Img
							src={vendorsWithImages[2].image as string}
							alt={vendorsWithImages[2].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-2"
						/>
					</div>
				)}
				{vendorsWithImages[3] && (
					<div
						className={Styles.bottomImageRight}
						data-testid="celebration-photo-grid-bottom-image-right"
					>
						<Img
							src={vendorsWithImages[3].image as string}
							alt={vendorsWithImages[3].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-3"
						/>
					</div>
				)}
			</div>
		</div>
	);
};
